import styled from 'styled-components';

/**
 * Styled components for WelcomeContent
 * Provides consistent styling for the welcome landing page
 */

export const WelcomeContainer = styled.section.withConfig({
  shouldForwardProp: (prop) => prop !== 'headerHeight',
})`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: calc(100vh - ${({ headerHeight }) => headerHeight}px);
  padding: 2rem;
  background: linear-gradient(135deg, #f4f6f9 0%, #e8ebf0 100%);
  text-align: center;
  transition: all 0.3s ease;
  animation: fadeIn 0.5s ease;

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

export const WelcomeHeader = styled.div`
  animation: slideDown 0.6s ease;

  @keyframes slideDown {
    from {
      opacity: 0;
      transform: translateY(-20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

export const Heading = styled.h1`
  font-size: 2.5rem;
  color: #6846d1;
  margin-bottom: 1rem;
  font-weight: 700;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
`;

export const Subtext = styled.p`
  font-size: 1.125rem;
  color: #6c757d;
  margin-top: 0;
  line-height: 1.6;
  max-width: 600px;
  margin: 0 auto;
`;
